export interface OrderRecord {
    id: string | number;
    items: any[];
    total: number;
    status: 'Delivered' | 'In Transit' | 'Processing' | 'pending';
    createdAt: string;
    customerInfo: {
        name: string;
        email: string;
        phone: string;
    };
    date?: string;
    statusColor?: string;
}

const ORDERS_KEY = 'petcare_orders';

export const getOrdersFromStorage = (): OrderRecord[] | null => {
    try {
        const data = localStorage.getItem(ORDERS_KEY);
        if (!data) return [];
        return JSON.parse(data);
    } catch {
        return [];
    }
};

export const saveOrdersToStorage = (orders: OrderRecord[]): void => {
    localStorage.setItem(ORDERS_KEY, JSON.stringify(orders));
};

export const addOrderToStorage = (order: OrderRecord): void => {
    const orders = getOrdersFromStorage() || [];
    orders.unshift(order);
    saveOrdersToStorage(orders);
};
